import React, { useState } from 'react';
import { Clock, Users2 } from 'lucide-react';
import ShiftWorkTab from './ShiftWorkTab';
import ShiftGroupsPage from '../ShiftGroups/ShiftGroupsPage';
import './styles/ShiftsPage.css';

type ShiftsTabId = 'work' | 'groups';

const TABS: Array<{ id: ShiftsTabId; label: string; icon: React.ComponentType<{ size?: number; strokeWidth?: number }> }> = [
  { id: 'work', label: 'Turno laboral', icon: Clock },
  { id: 'groups', label: 'Grupos', icon: Users2 },
];

const ShiftsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ShiftsTabId>('work');

  return (
    <div className="shifts-page-tabs">
      <nav className="shifts-page-tabs__nav" role="tablist" aria-label="Secciones de turnos">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              id={`shifts-tab-${tab.id}`}
              aria-selected={isActive}
              aria-controls={`shifts-panel-${tab.id}`}
              className={`shifts-page-tabs__btn${isActive ? ' is-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={16} strokeWidth={2.25} />
              {tab.label}
            </button>
          );
        })}
      </nav>

      <div
        role="tabpanel"
        id={`shifts-panel-${activeTab}`}
        aria-labelledby={`shifts-tab-${activeTab}`}
        className="shifts-page-tabs__panel"
      >
        {activeTab === 'work' ? <ShiftWorkTab /> : <ShiftGroupsPage />}
      </div>
    </div>
  );
};

export default ShiftsPage;
